import axios from 'axios';

// Use relative URL so it works on any domain (localhost or Railway)
const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration and network errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401/403 (token invalid/expired)
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // Handle network errors (no response from server)
    // This can happen if server is down, cold starting, or token is corrupted
    if (!error.response && error.message === 'Network Error') {
      console.error('Network error - server may be unavailable');
      // If we have a token but can't reach the server, the token might be invalid
      // Don't auto-logout on network errors as it could be temporary
    }

    return Promise.reject(error);
  }
);

export default api;
